import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import mixpanel from 'mixpanel-browser';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
}

root.render(
  <StrictMode>
    <ColorModeScript />
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>
);
